import { createZustandStore } from '../createZustandStore';
import type {
  IAlertSlice,
  IBillingInfoFormSlice,
  IEmailPlansSlice,
  IPaymentMethodsSlice,
  IUpdateBillingSlice,
} from '../slices';
import {
  createAlertSlice,
  createBillingInfoFormSlice,
  createEmailPlansSlice,
  createPaymentMethodsSlice,
  createUpdateBillingSlice,
} from '../slices';

export type IBillingInfoPageStore = IBillingInfoFormSlice &
  IPaymentMethodsSlice &
  IUpdateBillingSlice &
  IEmailPlansSlice &
  IAlertSlice;

export const useBillingInfoPageStore = createZustandStore(
  createBillingInfoFormSlice,
  createPaymentMethodsSlice,
  createUpdateBillingSlice,
  createAlertSlice,
  createEmailPlansSlice
);
